module.exports = __webpack_public_path__ + "img/Unidad9-3.1e62b344.png";